import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import swal from 'sweetalert2';

@Component({
  selector: 'app-lms-content-show',
  templateUrl: './lms-content-show.component.html',
  styleUrls: ['./lms-content-show.component.scss']
})
export class LmsContentShowComponent implements OnInit {

  apps = []
  selectedAppContent: number =0;
  app_id
  modalFor
    lms_model={
    content_scripts: '',
    teachers_notes: '',
    description	: '',
  }
  file :File
  selected_app_tag ='64884b753ec230f996841247'
  selected_resources = []
  s3MediaUrl = environment?.apiUrls?.s3MediaUrl
  current_data: any
  current_id:any
  current_url:any
  constructor(
    private _sanitizer: DomSanitizer,
    private apiService: ApiService, private modalService: NgbModal,
    private activatedRoute: ActivatedRoute) {
    this.current_url = activatedRoute.snapshot.routeConfig.path
    if(this.current_url !=="digital-assets/:id"){
    this.activatedRoute.paramMap.subscribe(params => {
      let id = params.get('id');
      this.getAppsByTopic(id)
    })
  }
    if(this.current_url ==="digital-assets/:id"){
      activatedRoute.paramMap
      .subscribe((params: any) => {
        this.current_id = params.get('id');
      this.getDigitalAssets(this.current_id)
      })
    }
    

    
  }
  
 
  ngOnInit(): void {
  }

    getAppsByTopic(id) {
    this.apiService.getAppsByTopicWithoutToken(id).subscribe((res: any) => {
      if (res.isSuccess) {
        this.apps = res?.data
      }
    });
    }
   showContent(index: number): void {
    this.selectedAppContent = index;
   }
  getAppTagId(event:any){
  this.selected_app_tag
  }
  getResourceId(event:any){
  this.selected_resources
  }
  getDigitalAssets(id) {
    this.apiService.getAssetsById(id).subscribe((res: any) => {
      this.current_data = res?.data[0];
    });
  }
  
}

